import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { EActionState, IAppointmentCombinedState } from 'models';
import { resetState } from 'store/common/slice';
import { initialState } from './state';

const slice = createSlice({
	name: '@@followups/update',
	initialState,
	reducers: {
		// eslint-disable-next-line @typescript-eslint/no-unused-vars
		INIT_START: (state, action: PayloadAction<{ activityId: string; followUpId: string; opportunityId: string; onSuccess: () => PayloadAction<any> }>) => {
			state.init = EActionState.RUNNING;
			state.activityId = action.payload.activityId;
			state.followUpId = action.payload.followUpId;
			state.opportunityId = action.payload.opportunityId;
			state.onSuccess = action.payload.onSuccess;
		},
		INIT_COMPLETED: (state, action: PayloadAction<{ followUps: IAppointmentCombinedState[] }>) => {
			state.init = EActionState.COMPLETED;
			state.followUps = action.payload.followUps;
			const followUp = action.payload.followUps.find(fu => fu.id === state.followUpId);
			state.form.formData.followUpResult.newValue = followUp?.comments || '';
		},
		INIT_FAILED: state => {
			state.init = EActionState.FAILED;
		},
		INIT_FLUSH: state => {
			resetState(state, initialState);
		},
		UPDATE_START: (state, action: PayloadAction<{ scheduleNext: boolean }>) => {
			state.update = EActionState.RUNNING;
		},
		UPDATE_COMPLETED: state => {
			state.update = EActionState.COMPLETED;
		},
		UPDATE_FAILED: state => {
			state.update = EActionState.FAILED;
		},
		OPEN_DIALOG: state => {
			state.open = true;
		},
		CLOSE_DIALOG: state => {
			state.open = false;
		},
		SET_FOLLOW_UP_RESULT: (state, action: PayloadAction<string>) => {
			state.form.formData.followUpResult.newValue = action.payload;
		},
		RESET_FORM: state => {
			resetState(state.form, initialState.form);
		}
	}
});

export const { reducer } = slice;
export const actionCreator = slice.actions;
